import React, { useState, useEffect } from "react";
import { pushEventToDataLayer } from "../../helper/datalayer-utils";
import "./new-top-banner.m.css";

const FEATURES = [
  { title: "Search & Share", subtitle: "Features" },
  { title: "User-Friendly", subtitle: "Design" },
  { title: "Access to", subtitle: "Archives" },
];

const FeatureItem = ({ title, subtitle }) => (
  <div styleName="epaper-feature">
    <span styleName="epaper-feature-bar" />
    <div styleName="epaper-feature-text">
      <p styleName="epaper-feature-title">{title}</p>
      <p styleName="epaper-feature-subtitle">{subtitle}</p>
    </div>
  </div>
);

const NewTopBanner = ({ sectionPage = false }) => {
  const [isMobile, setIsMobile] = useState(false);

  if (typeof window !== "undefined" &&
    window.location.pathname === "/union-budget-2026") {
    return null;
  }

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleBannerClick = () => {
    console.log("ePaper Banner clicked");
    window.open(
      "https://epaper.deccanherald.com/subscribe?utm_source=dhsite&utm_medium=top_banner&utm_campaign=awareness",
      "_blank"
    );
    if (window?.dataLayer) pushEventToDataLayer("ePaper_banner");
  };

  const desktopImage = "https://tpml-sites.s3.ap-south-1.amazonaws.com/images/Dktp_homesctn_banner.png";
  const mobileImage = "https://tpml-sites.s3.ap-south-1.amazonaws.com/images/MW_homesctnbanner.png";

  const height = isMobile ? "58px" : "103px";

  return (
    <div styleName="epaper-banner" style={sectionPage ? { marginBottom: "2rem", height } : { height, overflow: "hidden", marginBottom: "16px" }} onClick={handleBannerClick}>
      <div styleName="epaper-left">
        <img
          src={isMobile ? mobileImage : desktopImage}
          alt="E-paper on multiple devices"
          styleName="epaper-device"
        />

        <div styleName="epaper-text">
          <h2 styleName="epaper-heading">
            <span>ANYTIME, ANYWHERE.</span>
          </h2>

          <p styleName="epaper-subheading">
            Experience a more refined e-paper today
          </p>
        </div>
      </div>

      {
        !isMobile && (
          <div styleName="epaper-features">
            {FEATURES.map((item, index) => (
              <FeatureItem key={index} {...item} />
            ))}
          </div>
        )
      }
      <button styleName="epaper-cta">
        <span class="hide-desktop">Subscribe</span>
        <span class="hide-mobile">Subscribe Now</span>
      </button>
    </div>
  );
};

export default NewTopBanner;
